<template>
  <section>
      
      <b-card-code title="Filter" no-body style="display: none;">
        <b-card>
          <b-row xl="12" sm="12">
            <b-col cols="12" md="3" class="mb-md-0 mb-2">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="ProvinceOptions"
                :reduce="(ProvinceOptions) => ProvinceOptions.value"
                id="v-Province"
                v-model="select_6"
                label="title"
                placeholder="--Select Province --"
                class="w-100"
              />
            </b-col>
            <b-col cols="12" md="3" class="mb-md-0 mb-2">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="RegencyOptions"
                :reduce="(RegencyOptions) => RegencyOptions.value"
                v-model="select_7"
                label="title"
                id="v-Regency"
                placeholder="--Select Regency --"
                class="w-100"
              />
            </b-col>
            <b-col cols="12" md="3" class="mb-md-0 mb-2">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="SiteOptions"
                :reduce="(SiteOptions) => SiteOptions.value"
                label="title"
                v-model="select_site"
                placeholder="Site"
                class="w-100"
              />
            </b-col>
            <b-col cols="12" md="3" class="mb-md-0 mb-2">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="StatusOptions"
                :reduce="(StatusOptions) => StatusOptions.value"
                label="title"
                v-model="select_status"
                placeholder="Status"
                class="w-100"
              />
            </b-col>
            <b-col cols="12" md="12" class="mb-md-0 mb-2">&nbsp;</b-col>
            <b-col cols="12" md="3" class="mb-md-0 mb-2">
              <b-button
                class="sidebar-center"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                @click="filterz()"
                variant="outline-primary"
              >
                <feather-icon icon="SearchIcon" /> Filter
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-card-code>
      <b-card-code title="Data" no-body>
        <b-overlay
          :show="show"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
        >
          <b-card>
            <b-row>
              <b-col cols="2" style="display: none;">
                <div>
                  <!-- Add -->
                  <b-link :to="{ path: '/sparing-device/installation' }">
                    <b-button
                      class="ml-1 mb-1"
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-primary"
                    >
                      <feather-icon icon="PlusIcon" /> Installation
                    </b-button>
                  </b-link>
                </div>
              </b-col>
              <!-- <b-col cols="12" xl="2" lg="12" md="12" sm="12" xs="12">
                <div>
                  <p class="text-nowrap mb-md-0 mr-1 align-left">
                    Total : {{ totalRows }}
                  </p>
                </div>
              </b-col>
              <b-col cols="12" xl="2" lg="12" md="12" sm="12" xs="12">
                <div>
                  <p class="text-nowrap mb-md-0 mr-1 align-left">
                    Online : {{ totalActive }}
                  </p>
                </div>
              </b-col>
              <b-col cols="12" xl="2" lg="12" md="12" sm="12" xs="12">
                <div>
                  <p class="text-nowrap mb-md-0 mr-1 align-left">
                    Offline : {{ totalOffline }}
                  </p>
                </div>
              </b-col>
              <b-col cols="12" xl="2" lg="12" md="12" sm="12" xs="12">
                <div>
                  <p class="text-nowrap mb-md-0 mr-1 align-left mr-2">
                    Error : {{ totalError }}
                  </p>
                </div>
              </b-col> -->
            </b-row>
            <div class="d-none justify-content-between flex-wrap">
              <!-- sorting  -->
              <b-form-group
                label="Sort"
                label-size="sm"
                label-align-sm="left"
                label-cols-sm="3"
                label-for="sortBySelect"
              >
                <b-input-group size="sm">
                  <b-form-select
                    id="sortBySelect"
                    v-model="sortBy"
                    :options="sortOptions"
                  >
                    <template #first>
                      <option value="">none</option>
                    </template>
                  </b-form-select>
                  <b-form-select v-model="sortDesc" size="sm" :disabled="!sortBy">
                    <option :value="false">Asc</option>
                    <option :value="true">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
              <!-- filter -->
              <b-form-group
                label="Filter"
                label-cols-sm="2"
                label-align-sm="left"
                label-size="sm"
                label-for="filterInput"
                class="mr-1"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filterInput"
                    v-model="filter"
                    type="search"
                    placeholder="Type to Search"
                  />
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">
                      Clear
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>
            <b-table
              striped
              hover
              responsive
              class="position-relative"
              :items="items"
              :fields="fields"
              @sort-changed="sortChanged"
            >
              <template #cell(created_at)="data">
                {{ dateFormat(data.value) }}
              </template>
              <template #cell(device_code)="row">
                <b-link
                  :to="{ path: '/sparing-device/detail/' + row.item.device_id }"
                >
                  <span>{{ row.item.device_code }}</span>
                </b-link>
              </template>
              <template #cell(device_serial_number)="row">
                <b-link
                  :to="{ path: '/sparing-device/detail/' + row.item.device_id }"
                >
                  <span>{{ row.item.device_serial_number }}</span>
                </b-link>
              </template>
              <template #cell(device_value)="row">
                {{ row.item.device_value+row.item.device_default_unit }}
              </template>
              <template #cell(device_status)="data">
                <b-badge :variant="status[1][data.value]">
                  {{ status[0][data.value] }}
                </b-badge>
              </template>
            </b-table>
            <b-card-body>
              <Pagination :current-page.sync="currentPage" :per-page.sync="perPage" :total-rows="totalRows" @filter="handleFilter" />
            </b-card-body>
          </b-card>
        </b-overlay> 
      </b-card-code>
  </section>
</template>
<script>
import Pagination from '@/views/general/components/Pagination.vue'
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import {
  BCol,
  BOverlay,
  BCard,
  BRow,
  BTable,
  BImg,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BLink,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import { mapState } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import store from "@/store/index";

export default {
  components: {
    BCardCode,
    vSelect,
    BCol,
    BOverlay,
    BCard,
    BRow,
    BTable,
    BImg,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BLink,
    BDropdown,
    BDropdownItem,
    ToastificationContent,
    Pagination,
  },
  data() {
    return {
      dir: false,
      show: false,
      currentPage: 1,
      perPage: 10,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      select_6: "",
      select_7: "",
      select_8: "",
      select_9: "",
      select_site: "",
      select_status: "",
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      StatusOptions: [
        { title: 'Online', value: 'AC' },
        { title: 'Offline', value: 'ER' },
        { title: 'Error', value: 'FL' },
      ],
      status: [
        {
          FL: "Error",
          AC: "Online",
          ER: "Offline",
        },
        {
          FL: "light-warning",
          AC: "light-success",
          ER: "light-danger",
        }
      ]
    }
  },
  computed: {
    ...mapState({
      ProvinceOptions: (state) => state.region.province,
      RegencyOptions: (state) => state.region.regency,
      DistrictOptions: (state) => state.region.district,
      SiteOptions: (state) => state.site.options,
      LocationOptions: (state) => state.location.options,
      totalRows: (state) => state.sparing.deviceList.totalRows,
      totalActive: (state) => state.sparing.deviceList.totalActive,
      totalOffline: (state) => state.sparing.deviceList.totalOffline,
      totalError: (state) => state.sparing.deviceList.totalError,
      fields: (state) => state.sparing.deviceList.fields,
      items: (state) => state.sparing.deviceList.items,
      pageOptions: (state) => state.sparing.deviceList.pageOptions,
    }),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    totalExpenses() {
      return this.items.reduce((accum, item) => {
        // Assuming expenses is the field you want to total up
        return accum + parseFloat(item.expenses);
      }, 0.0);
    },
    dateFormat() {
      return (create_at) => this.$options.filters.formatDate(create_at);
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        this.dir = true;
        return this.dir;
      }
      this.dir = false;
      return this.dir;
    },
  },
  watch: {
    select_6(obj) {
      this.$store.dispatch("site/setFilterProvince", obj);
      return this.$store.dispatch("region/regency", obj);
    },
    select_7(obj) {
      this.$store.dispatch("site/setFilterRegency", obj);
      return this.$store.dispatch("region/district", obj);
    },
  },
  methods: {
    handleFilter(currentPage, perPage) {
      this.currentPage = currentPage
      this.perPage = perPage
      this.filterz()
    },
    sortChanged({ sortBy, sortDesc, sortDirection }) {
      this.sortBy = sortBy
      this.sortDesc = sortDesc
      this.sortDirection = sortDirection
      this.filterz()
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.$store.state.sparing.deviceList.totalRows = filteredItems.length;
      this.$store.state.sparing.deviceList.totalActive =
        filteredItems.filter((f) => f.device_status == "IN").length;
      this.$store.state.sparing.deviceList.totalOffline =
        filteredItems.filter((f) => f.device_status == "ER").length;
      this.$store.state.sparing.deviceList.totalError =
        filteredItems.filter((f) => f.device_status == "FL").length;
      this.currentPage = 1;
    },
    advanceSearch(val) {
      this.searchTerm = val;
    },
    rowOnDelete(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete everything.", {
          title: "Please Confirm",
          size: "sm",
          okVariant: "primary",
          okTitle: "Yes",
          cancelTitle: "No",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.$store.dispatch("device/remove", id).then(
              (response) => {
                if (response.status === 200) {
                  this.$store.dispatch("device/getAll");
                  this.notification(
                    "Success",
                    "CheckIcon",
                    "success",
                    "You have successfully"
                  );
                } else {
                  this.notification(
                    "Failed",
                    "CloseIcon",
                    "danger",
                    "You have unsuccessful"
                  );
                }
              },
              (error) => {
                this.notification(
                  "Failed",
                  "CloseIcon",
                  "danger",
                  "You have unsuccessful"
                );
              }
            );
          }
        });
    },
    notification(a, b, c, d) {
      this.$toast({
        component: ToastificationContent,
        position: "top-right",
        props: { title: a, icon: b, variant: c, text: d },
      });
    },
    filterz() {
      this.show = true
      const orderBy = this.sortBy ? { [this.sortBy]: this.sortDesc ? 'desc' : 'asc' } : ''
      this.params = {
        province_id: this.select_6,
        regency_id: this.select_7,
        district_id: this.select_8,
        site_id: this.select_site,
        status: this.select_status,
        page: this.currentPage,
        limit: this.perPage,
      };
      if (orderBy) {
        let mappingOrder = orderBy
        Object.keys(orderBy).forEach(key => {
          if (key === 'site_name') {
            mappingOrder = {
              locations: {
                areas: {
                  sites: {
                    name: orderBy[key],
                  },
                },
              },
            }
          } else if (key === 'area_name') {
            mappingOrder = {
              locations: {
                areas: {
                  name: orderBy[key],
                },
              },
            }
          } else if (key === 'location_name') {
            mappingOrder = {
              locations: {
                name: orderBy[key],
              },
            }
          } else if (key === 'device_name') {
            mappingOrder = { name: orderBy[key] }
          } else if (key === 'device_value') {
            mappingOrder = { 
              device_values: {
                _max: {
                  value: orderBy[key]
                }
              }
            }
          }
        })
        this.params.orderBy = JSON.stringify(mappingOrder)
      }

      
      // if (!this.select_6) {
      //   this.$store.state.sparing.deviceList.items = []
      //   this.$store.state.sparing.deviceList.totalRows = 0
      // } else {}
      this.$store.dispatch("sparing/getDeviceList", this.params)
      this.show = false
    },
    setData() {
      this.params = {
        province_id: this.select_6,
        regency_id: this.select_7,
        district_id: this.select_8,
        site_id: this.select_site,
        status: this.select_status,
        page: this.currentPage,
        limit: this.perPage,
      };
      this.$store.dispatch("sparing/getDeviceList", this.params)
      this.show = false
    },
  },
  directives: {
    Ripple,
  },
  created() {
    this.show = true
    this.$store.state.sparing.deviceList.totalRows = this.items.length;
    this.$store.state.sparing.deviceList.totalActive = this.items.filter(
      (f) => f.device_status == "IN"
    ).length;
    this.$store.state.sparing.deviceList.totalOffline = this.items.filter(
      (f) => f.device_status == "ER"
    ).length;
    this.$store.state.sparing.deviceList.totalError = this.items.filter(
      (f) => f.device_status == "FL"
    ).length;
    this.$store.dispatch("region/province")
    this.$store.dispatch("site/setFilterRegency", "")
    this.$store.dispatch("location/getAll")
    this.setData()
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
